import React, { useEffect } from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Displays',
  },
  {
    path: 'Modal_Component',
    breadcrumbName: 'Modal',
  },
];

const Modal = () => {
  useEffect(() => document.querySelectorAll('[data-rule="layer"]').forEach((el) => new IMI.Layer(el)), []);
  return (
    <>
      <PageHeader title="Layer" breadcrumb={{ routes }} subTitle="Layer" style={{ padding: 10 }} />

      <div className="MF_area">
        <button className="btn btn_fill_blue" data-rule="layer" data-target="#layer">Click me</button>
        <div className="layer blue" id="layer">
          <div className="inner">
            <div className="title">
              Title
                <a href="#" onClick={e => e.preventDefault()} className="close" data-label="close"></a>
            </div>
            <div className="cont">
              Layer Contents! Layer Contents!<br />
              Layer Contents! Layer Contents!<br />
              Layer Contents! Layer Contents!<br />
              Layer Contents! Layer Contents!<br />
              Layer Contents! Layer Contents!<br />
            </div>
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<button class="btn btn_fill_blue" data-rule="layer" data-target="#layer">Click me</button>
<div class="layer blue" id="layer">
  <div class="inner">
    <div class="title">
      Title
        <a href="javascript:;" class="close" data-label="close"></a>
    </div>
    <div class="cont">
      Layer Contents! Layer Contents!<br />
      Layer Contents! Layer Contents!<br />
      Layer Contents! Layer Contents!<br />
      Layer Contents! Layer Contents!<br />
      Layer Contents! Layer Contents!<br />
    </div>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
          <TabPane tab="JAVASCRIPT" key="2">
            <CodeHighlight language="JS">
              {`var layers = document.querySelectorAll('[data-rule="layer"]');
for (var i = 0; i < layers.length; i++){ new Tab(layers[i]) }`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>


    </>
  );
}

export default Modal;
